import React from 'react'
import { useTheme } from '@/hooks/useTheme'
import { BaseText } from '@/components/base'

interface DateInputFieldProps {
  label: string
  value: string
  isFocused: boolean
  onPress: () => void
}

export const DateInputField: React.FC<DateInputFieldProps> = ({
  label,
  value,
  isFocused,
  onPress,
}) => {
  const theme = useTheme()

  return (
    <div
      onClick={onPress}
      style={{
        position: 'relative',
        flex: 1,
        minWidth: 0, // Позволяет flex элементам сжиматься
        height: '70px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '8px 12px',
        borderBottomWidth: '1px',
        borderBottomColor: isFocused ? theme.colors.label.primary : '#FFFFFF',
        borderBottomStyle: 'solid',
        boxSizing: 'border-box',
      }}
    >
      {/* Label */}
      <BaseText
        fontFamily="medium"
        fontSize={16}
        style={{
          position: 'absolute',
          left: 12,
          top: 10,
          color: theme.colors.label.labelTextInput,
          pointerEvents: 'none',
        }}
      >
        {label}
      </BaseText>

      {/* Value */}
      <input
        type="text"
        value={value}
        readOnly
        style={{
          width: '100%',
          fontSize: '16px',
          color: theme.colors.label.textTextInput,
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          paddingTop: '20px',
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0,
          pointerEvents: 'none',
          fontWeight: '500',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        }}
      />
    </div>
  )
}
